var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoutIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.16667 4.66667H9.16667C9.625 4.66667 10 4.29167 10 3.83333C10 3.375 9.625 3 9.16667 3H4.16667C3.25 3 2.5 3.75 2.5 4.66667V16.3333C2.5 17.25 3.25 18 4.16667 18H9.16667C9.625 18 10 17.625 10 17.1667C10 16.7083 9.625 16.3333 9.16667 16.3333H4.16667V4.66667Z",
    fill: "#084F4B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2083 10.2081L14.8833 7.88312C14.8254 7.82358 14.751 7.78269 14.6696 7.76568C14.5883 7.74867 14.5037 7.75631 14.4268 7.78763C14.3498 7.81896 14.284 7.87253 14.2376 7.9415C14.1913 8.01047 14.1666 8.0917 14.1667 8.17479V9.66646H8.33333C7.875 9.66646 7.5 10.0415 7.5 10.4998C7.5 10.9581 7.875 11.3331 8.33333 11.3331H14.1667V12.8248C14.1667 13.1998 14.6167 13.3831 14.875 13.1165L17.2 10.7915C17.3667 10.6331 17.3667 10.3665 17.2083 10.2081Z",
    fill: "#084F4B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoutIcon);
export default __webpack_public_path__ + "static/media/logout-icon.6976770e096a36d81336c3aebf4c7e47.svg";
export { ForwardRef as ReactComponent };